import { useMemo } from 'react';
import { createTheme } from '@mui/material';
import lightMode from './lightMode';
import { default as components } from './components';
import { default as dimentions } from './utils/dimentions';

export default () => useMemo(() => createTheme({ ...lightMode, dimentions, components }), []);
